/* unplugin-vue-components disabled */import script from "./SelectCouponList.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCouponList.vue?vue&type=script&setup=true&lang=js"

import "./SelectCouponList.vue?vue&type=style&index=0&id=83c5323a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83c5323a"]])

export default __exports__